
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";

export default Vue.extend({
	data(){
		return {
		};
	},
	props: {
		state: {
			type: Object as ()=>SaleEditState,
			required: true,
		}
	},
	computed: {
		title():{toString():string}{
			return `${this.$ct("EditDeliveryDate")}`;
		},
		confirmText():TranslateResult{
			return this.$ct("common.confirm");
		},
	},

	methods: {
		close() {
			this.$emit("close");
		},
	},
	mounted(){

	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
